module.exports = __webpack_public_path__ + "img/branding.e50396c4.png";